<div class="custom-form main-form">
	<div [formGroup]="formGroup" *ngIf="formInitialized | async else loading">
		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company name</label>
			</div>
			<div class="setting-field">
				<dx-text-box as-validator formControlName="nameOfCompany"></dx-text-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company domain</label>
			</div>
			<div class="setting-field">
				<dx-text-box as-validator formControlName="fullDomainOfCompany"></dx-text-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company owner</label>
			</div>
			<div class="setting-field">
				<dx-text-box as-validator formControlName="companyOwner"></dx-text-box>
			</div>
		</div>


		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company creation date</label>
			</div>
			<div class="setting-field">
				<dx-date-box as-validator formControlName="companyCreationDate" [displayFormat]="format"></dx-date-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company date format</label>
			</div>
			<div class="setting-field">
				<dx-select-box [searchMode]="'contains'" [searchExpr]="'title'"
					[searchTimeout]="200" [minSearchLength]="0" [searchEnabled]="true" [showDataBeforeSearch]="true"
					[deferRendering]="false" [dataSource]="dateFormats" [(value)]="selectedDateFormat"></dx-select-box>
			</div>
		</div>

		<div *ngIf="iTest | async as content" class="settings-container">
			<div class="setting-description">
				<label class="form-label">Company timezone*</label>
			</div>
			<div class="setting-field">
				<dx-select-box displayExpr="title" valueExpr="id" [searchMode]="'contains'" [searchExpr]="'title'"
					[searchTimeout]="200" [minSearchLength]="0" [searchEnabled]="true" [showDataBeforeSearch]="true"
					[deferRendering]="false" [dataSource]="content" [(value)]="selectedIndex" [disabled]="isTimezoneEditingDisabled()"></dx-select-box>
			</div>
		</div>
		<div>*The timezone of the company is used for the scheduling of financial integration links. <br>
			Adjusting the timezone while a link has been scheduled does not update the execution time of the existing
			schedule. <br>
			It will be required to reschedule the link by removing and adding the schedule in order for changes to take
			effect. </div>
		<br>
		<ng-container *ngIf="isCompanyOwner || canManageCompany">
			<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveForm()">
				Save configuration
			</button>
		</ng-container>
	</div>
	<ng-template #loading>Loading....</ng-template>
</div>
